import React from 'react';
import '../styles/Pagination.css';

interface PaginationProps {
  /** 0-based page index, matching the backend. */
  page: number;
  totalPages: number;
  onChange: (next: number) => void;
}

const PT_NUM: Record<number, string> = {
  1: 'I', 2: 'II', 3: 'III', 4: 'IV', 5: 'V',
  6: 'VI', 7: 'VII', 8: 'VIII', 9: 'IX', 10: 'X',
};

function roman(n: number): string {
  return PT_NUM[n] ?? String(n);
}

const Pagination: React.FC<PaginationProps> = ({ page, totalPages, onChange }) => {
  if (totalPages <= 1) return null;

  const prevDisabled = page <= 0;
  const nextDisabled = page >= totalPages - 1;
  const human = page + 1;

  return (
    <nav className="pagination" aria-label="Paginação">
      <button
        type="button"
        className="pagination__step"
        onClick={() => onChange(page - 1)}
        disabled={prevDisabled}
        aria-label="Página anterior"
      >
        ← anterior
      </button>

      <div className="pagination__center" aria-live="polite">
        <span className="pagination__rule" aria-hidden="true" />
        <span className="pagination__counter">
          Página <strong>{roman(human)}</strong> de {roman(totalPages)}
        </span>
        <span className="pagination__rule" aria-hidden="true" />
      </div>

      <button
        type="button"
        className="pagination__step"
        onClick={() => onChange(page + 1)}
        disabled={nextDisabled}
        aria-label="Página seguinte"
      >
        seguinte →
      </button>
    </nav>
  );
};

export default Pagination;
